

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"17","height":"17","viewBox":"0 0 17 17"}, rest), ["\n  ", h('g', {"fill":"#E94040"}, ["\n    ", h('path', {"d":"M8.16 0a8.16 8.16 0 1 0 8.16 8.16A8.169 8.169 0 0 0 8.16 0zm0 14.28a6.12 6.12 0 1 1 6.12-6.12 6.127 6.127 0 0 1-6.12 6.12z"}, []), "\n    ", h('path', {"d":"M10.2 7.14H6.12a1.02 1.02 0 0 0 0 2.04h4.08a1.02 1.02 0 0 0 0-2.04z"}, []), "\n  "]), "\n"]);
};

        